export class PerfilFilter {
   public nombre: string;
   public activo: number;
   public emisorid: string;
   public usuarioId: string;
}
